import type { ColumnGroupType, ColumnType, ColumnsType } from "antd/es/table";
import { debounce as _debounce, isArray, mergeWith } from "lodash";

const DEBOUNCE_WAIT = 300;

export function mergeWithArray<T1 extends Object, T2 extends Object>(
  obj: T1 = {} as T1,
  src: T2
) {
  return mergeWith({}, obj, src, (objValue, srcValue) => {
    if (isArray(objValue)) return objValue.concat(srcValue);
  });
}

export function filterArray<T>(
  ...array: Array<T | undefined | null | false>
): T[] {
  return filterFalse(array);
}

export function filterFalse<T>(
  array: Array<T | undefined | null | false>
): T[] {
  return array.filter((t): t is T => !!t);
}

export function filterColumns<TColumn>(
  array: Array<
    ColumnType<TColumn> | ColumnGroupType<TColumn> | undefined | null | false
  >
): ColumnsType<TColumn> {
  return filterFalse(array);
}

export function debounce<T extends (...args: any) => any>(func: T) {
  return _debounce(func, DEBOUNCE_WAIT);
}

export function isDemo() {
  return process.env.ARAGRO_ENV === "demo";
}

export function isSignUpEnabled() {
  return !!process.env.NEXT_PUBLIC_TURNSTILE_SITE_KEY?.trim();
}

export function unaccent(input: string): string {
  return input
    .toString()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");
}

export function downloadBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
  URL.revokeObjectURL(url);
}
